import API from "../components/helpers/endpointservice";
import Actions from './api';
// ?invoiceNumber=${data?.Invoice_number?data.Invoice_number:""}&invoiceFromDate=${data?.invoice_from_date?data.invoice_from_date:""}&invoiceToDate=${data?.invoice_to_date?data.invoice_to_date:""}&Status=${data?.status?data.status:""}&SortBy=${data?.sortBy?data.sortBy:""}&SortOrder=${data?.sortOrder?data.sortOrder:""}&PageNumber=${data?.PageNumber?data.PageNumber:""}&PageSize=${data?.PageSize?data.PageSize:""}
export const GetInvoiceData = (data) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        //Loader true
        dispatch({ type: "IS_LOADER", data: true });
        Actions.GET(`${API.GET_INVOICE_DETAILS}?InvoiceNumber=${data?.invoice_number?data.invoice_number:""}&InvoiceFromDate=${data?.invoice_from_date?data.invoice_from_date:""}&InvoiceToDate=${data?.invoice_to_date?data.invoice_to_date:""}&Status=${data?.status?data.status:""}&SortBy=${data?.sortBy?data.sortBy:""}&SortOrder=${data?.sortOrder?data.sortOrder:""}&PageNumber=${data?.PageNumber?data.PageNumber:""}&PageSize=${data?.PageSize?data.PageSize:""}`).then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            console.log(res.data);
            
            dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
            dispatch({ type: "IS_LOADER", data: false });
            return res.data
            
          }
          else {
            reject(new Error("No data in response"));
            dispatch({ type: "IS_LOADER", data: false });
           
          }
          //Loader false
          
        }).catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
      });
    };
  };


  export const DownloadPdf = (invoicePdfUrl) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        //Loader true
        dispatch({ type: "IS_LOADER", data: true });
        Actions.GET(`${API.DOWNLOAD_PDF}?invoicePDFUrl=${invoicePdfUrl}`).then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            console.log(res.data);
            
            dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
            dispatch({ type: "IS_LOADER", data: false });
            return res.data
            
          }
          else {
            reject(new Error("No data in response"));
            dispatch({ type: "IS_LOADER", data: false });
           
          }
          //Loader false
          
        }).catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
      });
    };
  };


  

// export const GetInvoiceData = (data) => {
//     return (dispatch) => {
//       return new Promise((resolve, reject) => {
//         // Set loader to true
//         dispatch({ type: "IS_LOADER", data: true });
  
//         // Construct the query string
//         const queryParams = new URLSearchParams();
  
//         if (data?.invoice_number) queryParams.append('invoiceNumber', data.invoice_number);
//         if (data?.invoice_from_date) queryParams.append('invoiceFromDate', data.invoice_from_date);
//         if (data?.invoice_to_date) queryParams.append('invoiceToDate', data.invoice_to_date);
//         if (data?.status) queryParams.append('Status', data.status);
//         if (data?.sortBy) queryParams.append('SortBy', data.sortBy);
//         if (data?.sortOrder) queryParams.append('SortOrder', data.sortOrder);
//         if (data?.PageNumber) queryParams.append('PageNumber', data.PageNumber);
//         if (data?.PageSize) queryParams.append('PageSize', data.PageSize);
  
//         const queryString = queryParams.toString();
//         const apiUrl = `${API.GET_INVOICE_DETAILS}?${queryString}`;
  
//         // Make the API request
//         Actions.GET(apiUrl)
//           .then((res) => {
//             if (res.data) {
//               // Resolve with data and dispatch success
//               resolve(res.data);
//               console.log(res.data);
//               dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
//             } else {
//               // Reject if no data in response
//               reject(new Error("No data in response"));
//             }
//             // Set loader to false
//             dispatch({ type: "IS_LOADER", data: false });
//           })
//           .catch((error) => {
//             // Set loader to false on error
//             dispatch({ type: "IS_LOADER", data: false });
//             reject(error);
//           });
//       });
//     };
//   };
  


  export const GetParticularInvoice = (invoiceId) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        //Loader true
        dispatch({ type: "IS_LOADER", data: true });
        Actions.GET(`${API.GET_PARTICULAR_INVOICE}${invoiceId}`).then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            console.log(res.data);
            
            dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
            dispatch({ type: "IS_LOADER", data: false });
            return res.data
            
          }
          else {
            reject(new Error("No data in response"));
            dispatch({ type: "IS_LOADER", data: false });
           
          }
          //Loader false
          
        }).catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
      });
    };
  };

  export const GetParticularInvoiceLineItems= (invoiceId,data) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        //Loader true
        dispatch({ type: "IS_LOADER", data: true });
        Actions.GET(`${API.GET_PARTICULAR_INVOICE}${invoiceId}/line_items?ApplicationName=${data?.applicationname?data?.applicationname:""}&Type=${data?.type?data?.type:""}&BillingFromDate=${data?.billingfromdate?data?.billingfromdate:""}&BillingToDate=${data?.billingtodate?data.billingtodate:""}&SortBy=${data?.sortby?data.sortby:""}&SortOrder=${data?.sortorder?data?.sortorder:""}&PageNumber=${data?.pagenumber?data?.pagenumber:""}&PageSize=${data?.pagesize?data?.pagesize:""}`).then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            console.log(res.data);
            
            dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
            dispatch({ type: "IS_LOADER", data: false });
            return res.data
            
          }
          else {
            reject(new Error("No data in response"));
            dispatch({ type: "IS_LOADER", data: false });
           
          }
          //Loader false
          
        }).catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
      });
    };
  };

  export const GetInvoiceSummary= (invoiceId) => {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        //Loader true
        dispatch({ type: "IS_LOADER", data: true });
        Actions.GET(`${API.GET_PARTICULAR_INVOICE}${invoiceId}/summary_line_items`).then((res) => {
          if (res.data !== undefined) {
            resolve(res.data);
            console.log(res.data);
            
            dispatch({ type: "APPLICATION_LOADED_SUCCESS", data: res.data });
            dispatch({ type: "IS_LOADER", data: false });
            return res.data
            
          }
          else {
            reject(new Error("No data in response"));
            dispatch({ type: "IS_LOADER", data: false });
           
          }
          //Loader false
          
        }).catch((error) => {
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
      });
    };
  };